<template>
  <div class="home">
    <b-navbar ref="navbar" style="background-color: #000000;height: 85.5px;" type="#ffffff" toggleable variant="dark"
      class="mb-4 px-3 px-md-5 nav-custom">
      <b-navbar-brand href="#">
        <img :src="require('../assets/logo.svg')" style="width: 180px;height: auto;" alt="Responsive image"></img>
      </b-navbar-brand>

      <b-navbar-nav class="ml-auto">
        <b-button variant="outline-success" @click="contactUs">Contact Us</b-button>
      </b-navbar-nav>
    </b-navbar>

    <div class="content-custom">
      <b-container>
        <b-row>
          <b-col cols="12" md="6" class="mb-4">
            <b-card @click="navTo('260596-crypto-com-app')" title="Cryptocurrency App"
              :img-src="require('../assets/card1.png')" img-alt="Image" img-top img-height="252px" tag="article"
              class="mb-2 card-hover">
              <b-card-text>
                Detailed information about Cryptocurrency App, available markets, CRO lockup, Crypto deposits and
                withdrawals,
                referral program, and security
              </b-card-text>

              <div><span style="color: #737373;">113 articles</span></div>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-4">
            <b-card @click="navTo('10821904-crypto-com-level-up-experience')" title="Cryptocurrency Level Up Experience"
              :img-src="require('../assets/card2.png')" img-alt="Image" img-top img-height="252px" tag="article"
              class="mb-2 card-hover">
              <b-card-text>
                Detailed information about Cryptocurrency Level Up Experience - application, activation, rewards and
                benefits
              </b-card-text>

              <div><span style="color: #737373;">2 articles</span></div>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-4">
            <b-card @click="navTo('260584-crypto-com-prepaid-card')" title="Cryptocurrency Prepaid Card"
              :img-src="require('../assets/card3.png')" img-alt="Image" img-top img-height="252px" tag="article"
              class="mb-2 card-hover">
              <b-card-text>
                Everything to know about Cryptocurrency Prepaid Card - application, activation, usage and benefits
              </b-card-text>

              <div><span style="color: #737373;">48 articles</span></div>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-4">
            <b-card @click="navTo('13179648-crypto-com-visa-signature-credit-card-us-only')"
              title="Cryptocurrency Visa Signature Credit Card (US Only)" :img-src="require('../assets/card4.jpg')"
              img-alt="Image" img-top img-height="252px" tag="article" class="mb-2 card-hover">
              <b-card-text>
                Everything to know about the Cryptocurrency Visa Signature® Credit Card - Application and setup
              </b-card-text>

              <div><span style="color: #737373;">2 articles</span></div>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-4">
            <b-card @click="navTo('3488994-crypto-com-cash-account')" title="Cryptocurrency Cash Account"
              :img-src="require('../assets/card5.png')" img-alt="Image" img-top img-height="252px" tag="article"
              class="mb-2 card-hover">
              <b-card-text>
                Detailed information about Cryptocurrency Cash Account - Set up, Deposits, Withdrawals, Bank Transfers,
                Account
                Management
              </b-card-text>

              <div><span style="color: #737373;">45 article</span></div>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-4">
            <b-card @click="navTo('12137901-crypto-com-cash-earn-account')" title="Cryptocurrency Cash Earn Account"
              :img-src="require('../assets/card6.png')" img-alt="Image" img-top img-height="252px" tag="article"
              class="mb-2 card-hover">
              <b-card-text>
                Detailed information about Cryptocurrency Cash Earn Account
              </b-card-text>

              <div><span style="color: #737373;">7 articles</span></div>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-4">
            <b-card @click="navTo('19013313-crypto-com-cash-yield-account')" title="Cryptocurrency Cash Yield Account"
              :img-src="require('../assets/card7.png')" img-alt="Image" img-top img-height="252px" tag="article"
              class="mb-2 card-hover">
              <b-card-text>
                Detailed information about Cryptocurrency Cash Yield Account
              </b-card-text>

              <div><span style="color: #737373;">8 articles</span></div>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-4">
            <b-card @click="navTo('2031951-crypto-com-exchange')" title="Cryptocurrency Exchange"
              :img-src="require('../assets/card8.png')" img-alt="Image" img-top img-height="252px" tag="article"
              class="mb-2 card-hover">
              <b-card-text>
                Detailed information about Cryptocurrency Exchange - registration, account management, trading, CRO
                lockup,
                fees,
                referral program, supercharger and security
              </b-card-text>

              <div><span style="color: #737373;">389 articles</span></div>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-4">
            <b-card @click="navTo('9971368-crypto-com-exchange-hk')" title="Cryptocurrency Exchange (HK)"
              :img-src="require('../assets/card8.png')" img-alt="Image" img-top img-height="252px" tag="article"
              class="mb-2 card-hover">
              <b-card-text>
                Detailed information about Cryptocurrency Exchange (HK)
              </b-card-text>

              <div><span style="color: #737373;">4 articles</span></div>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-4">
            <b-card @click="navTo('2221157-crypto-com-onchain')" title="Cryptocurrency Onchain"
              :img-src="require('../assets/card9.jpg')" img-alt="Image" img-top img-height="252px" tag="article"
              class="mb-2 card-hover">
              <b-card-text>
                Detailed information about Cryptocurrency Onchain - onboarding, wallet management, deposit and
                withdrawal,
                Onchain
                Extension
              </b-card-text>

              <div><span style="color: #737373;">91 articles</span></div>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-4">
            <b-card @click="navTo('10959614-stocks-etfs')" title="Stocks & ETFs"
              :img-src="require('../assets/card10.jpg')" img-alt="Image" img-top img-height="252px" tag="article"
              class="mb-2 card-hover">
              <b-card-text>
                About Stocks & ETFs trading with Foris Capital US LLC via the Cryptocurrency App. Stocks are offered by
                Foris
                Capital US LLC, Member FINRA & SIPC.
              </b-card-text>

              <div><span style="color: #737373;">12 articles</span></div>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-4">
            <b-card @click="navTo('16577793-crypto-com-iras')" title="Cryptocurrency IRAs"
              :img-src="require('../assets/card11.png')" img-alt="Image" img-top img-height="252px" tag="article"
              class="mb-2 card-hover">
              <b-card-text>
                Detailed information about Cryptocurrency IRAs (Individual Retirement Account).
              </b-card-text>

              <div><span style="color: #737373;">11 articles</span></div>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-4">
            <b-card @click="navTo('1797283-crypto-com-pay-app-faq')" title="Cryptocurrency Pay - App FAQ"
              :img-src="require('../assets/card12.png')" img-alt="Image" img-top img-height="252px" tag="article"
              class="mb-2 card-hover">
              <b-card-text>
                Detailed information about Cryptocurrency Pay - supported currencies, wallets, transaction fees, rewards
                and
                refunds
              </b-card-text>

              <div><span style="color: #737373;">18 article</span></div>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-4">
            <b-card @click="navTo('3412419-crypto-com-price')" title="Cryptocurrency Price"
              :img-src="require('../assets/card13.png')" img-alt="Image" img-top img-height="252px" tag="article"
              class="mb-2 card-hover">
              <b-card-text>
                Detailed information about how Cryptocurrency Price can be navigated - from onboarding to watchlist and
                more.
              </b-card-text>

              <div><span style="color: #737373;">1 article</span></div>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-4">
            <b-card @click="navTo('2825200-crypto-com-tax')" title="Cryptocurrency Tax"
              :img-src="require('../assets/card14.png')" img-alt="Image" img-top img-height="252px" tag="article"
              class="mb-2 card-hover">
              <b-card-text>
                <br>
                <br>
              </b-card-text>

              <div><span style="color: #737373;">1 article</span></div>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-4">
            <b-card @click="navTo('2852834-crypto-com-nft')" title="Cryptocurrency NFT"
              :img-src="require('../assets/card15.jpg')" img-alt="Image" img-top img-height="252px" tag="article"
              class="mb-2 card-hover">
              <b-card-text>
                Cryptocurrency NFT is an off-chain platform that allows buyers and sellers to easily trade with
                collectibles(NFTs)
                without having previous experience.
              </b-card-text>

              <div><span style="color: #737373;">20 articles</span></div>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-4">
            <b-card @click="navTo('8287455-crypto-com-prime')" title="Cryptocurrency Prime"
              :img-src="require('../assets/card16.jpg')" img-alt="Image" img-top img-height="252px" tag="article"
              class="mb-2 card-hover">
              <b-card-text>
                Detailed information about Cryptocurrency Prime
              </b-card-text>

              <div><span style="color: #737373;">6 articles</span></div>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-4">
            <b-card @click="navTo('2012545-kyc-know-your-customer')" title="KYC - Know Your Customer"
              :img-src="require('../assets/card17.png')" img-alt="Image" img-top img-height="252px" tag="article"
              class="mb-2 card-hover">
              <b-card-text>
                All about KYC - Verification, documents, applications, Singpass, Source of Funds
              </b-card-text>

              <div><span style="color: #737373;">7 articles</span></div>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-4">
            <b-card @click="navTo('1512001-crypto-com-pay-for-business-merchant-faq')"
              title="Cryptocurrency Pay for Business - Merchant FAQ" :img-src="require('../assets/card18.png')"
              img-alt="Image" img-top img-height="252px" tag="article" class="mb-2 card-hover">
              <b-card-text>
                All about Cryptocurrency Pay for Business - Registration, Account, Integration, Payments and Refund
              </b-card-text>

              <div><span style="color: #737373;">28 articles</span></div>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-4">
            <b-card @click="navTo('3732417-crypto-com-shop')" title="Cryptocurrency Shop"
              :img-src="require('../assets/card19.png')" img-alt="Image" img-top img-height="252px" tag="article"
              class="mb-2 card-hover">
              <b-card-text>
                Detailed information about our Cryptocurrency Shop orders, shipping, product and billing details
              </b-card-text>

              <div><span style="color: #737373;">3 articles</span></div>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-4">
            <b-card @click="navTo('260617-our-company')" title="Our Company" :img-src="require('../assets/card20.png')"
              img-alt="Image" img-top img-height="252px" tag="article" class="mb-2 card-hover">
              <b-card-text>
                Detailed information about the Cryptocurrency Team and who we are
              </b-card-text>

              <div><span style="color: #737373;">8 articles</span></div>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-4">
            <b-card @click="navTo('2825244-security')" title="Security" :img-src="require('../assets/card21.jpeg')"
              img-alt="Image" img-top img-height="252px" tag="article" class="mb-2 card-hover">
              <b-card-text>
                Detailed information about APP Policy, Data Privacy, and Security Awareness
              </b-card-text>

              <div><span style="color: #737373;">7 articles</span></div>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-4">
            <b-card @click="navTo('10284375-crypto-com-web')" title="Cryptocurrency Web"
              :img-src="require('../assets/card22.png')" img-alt="Image" img-top img-height="252px" tag="article"
              class="mb-2 card-hover">
              <b-card-text>
                Detailed information about the desktop version of the Cryptocurrency App
              </b-card-text>

              <div><span style="color: #737373;">5 articles</span></div>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-4">
            <b-card @click="navTo('11261898-crypto-com-custody')" title="Cryptocurrency Custody"
              :img-src="require('../assets/card23.png')" img-alt="Image" img-top img-height="252px" tag="article"
              class="mb-2 card-hover">
              <b-card-text>
                <br>
                <br>
              </b-card-text>

              <div><span style="color: #737373;">2 articles</span></div>
            </b-card>
          </b-col>
        </b-row>

      </b-container>

      <Footer></Footer>
    </div>



  </div>
</template>

<script>
// @ is an alias to /src
import Footer from '@/components/Footer.vue';

export default {
  name: 'HomeView',
  components: {
    Footer,
  },
  // data() {
  //   return {
  //     showService: false
  //   }
  // },
  methods: {
    // handleScroll() {
    //   const navbar = this.$refs.navbar && this.$refs.navbar.$el;
    //   if (navbar) {
    //     const rect = navbar.getBoundingClientRect();
    //     this.showService = rect.bottom <= 0;
    //   } else {
    //     this.showService = window.scrollY > 85.5;
    //   }
    // },
    contactUs() {
      this.$ContactToUs()
    },
    navTo(val) {
      this.$router.push('/collections/' + val)
    }
  },
  // mounted() {
  //   window.addEventListener('scroll', this.handleScroll);
  //   this.handleScroll();
  // },
  // beforeDestroy() {
  //   window.removeEventListener('scroll', this.handleScroll);
  // }
}
</script>

<style scoped>
::v-deep .bg-dark {
  background-color: #000000 !important;
}

::v-deep nav a {
  color: #ffffff;
}

.card-title {
  color: #1a1a1a;
  font-size: 16px;
  font-weight: 600;
}

.card-text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

@media (min-width: 640px) {
  .card-text {
    -webkit-line-clamp: 2;
    line-height: 1.5;
    max-height: calc(1.5em * 2);
  }
}

.card-hover {
  cursor: pointer;
  transition: border-color 0.2s;
}

.card-hover:hover {
  border-color: black;
}

@media (min-width: 992px) {

  .nav-custom,
  .content-custom {
    padding-left: 232px !important;
    padding-right: 232px !important;
  }
}

.nav-custom {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
</style>
